export default "__VITE_ASSET__BD$2Y3aO__"